<template>
  <v-card class="mx-auto ma-2 py-2" min-width="300" max-width="380" elevation="2" outlined>
    <v-list-item @click="$router.push(`/${isPublic?'public':'obrero'}/job-details/${job._key}?tab=Summary`)">
      <v-icon medium class="pa-2">
        far fa-calendar
      </v-icon>
      <v-list-item-content class="pa-0">
        <v-card-title class="pa-1 font-weight-light">
          <span class="h6">{{job.startDate|formatShortDate}} at {{job.startDate|formatTime}}</span>
        </v-card-title>
        <v-card-subtitle class="pa-1">
          {{job.title}}
        </v-card-subtitle>
      </v-list-item-content>
    </v-list-item>

    <!--<v-list-item>
      <v-list-item-avatar @click="$router.push(`/${isPublic?'public':'obrero'}/job-details/${job._key}?tab=Summary`)">
        <v-img class="elevation-6" :src="require(`@/assets/${job.category}.svg`)"></v-img>
      </v-list-item-avatar>
      <v-list-item-content @click="$router.push(`/${isPublic?'public':'obrero'}/job-details/${job._key}?tab=Summary`)">
        <v-list-item-title class="title font-weight-light">
          {{job.title}}
        </v-list-item-title>
        <v-list-item-subtitle class="subtitle font-weight-light" v-if="fromSearch">
          ({{jobData.dist}} mi. away)
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action v-if="job.status!=='Draft' && !isPublic&& !fromSearch">
        <v-badge overlap color="error" v-if="job.showMessageWarning" content="!">
          <v-icon @click="$router.push(`/obrero/job-details/${job._key}?tab=Messages`)">chat</v-icon>
        </v-badge>
        <v-icon @click="$router.push(`/obrero/job-details/${job._key}?tab=Messages`)" v-else>chat</v-icon>
      </v-list-item-action>
    </v-list-item>-->
    <v-list-item>
      <v-chip class="ma-1" pill small>
        <v-avatar left>
          <v-icon>mdi-account-circle</v-icon>
        </v-avatar>
        <span class="caption">
          Manual E.
        </span>
      </v-chip>
      <v-chip class="ma-1" pill small>
        <v-avatar left>
          <v-icon>mdi-account-circle</v-icon>
        </v-avatar>
        <span class="caption">
          Jessica C.
        </span>
      </v-chip>
    </v-list-item>

    <!--<v-divider class="mx-4"></v-divider>-->
    <!--<v-row>
      <v-list-item class="mx-4" dense @click="$router.push(`/${isPublic?'public':'obrero'}/job-details/${job._key}?tab=Summary`)">
        <v-list-item-content style="height:64px">
          <span class="caption">{{job.jobDesc|formatDesc}}</span>
        </v-list-item-content>
      </v-list-item>
      <v-col cols="12" class="pl-1">
        <v-list class="pa-0 ma-0" dense color="transparent">
          <v-list-item style="height:40px" color="transparent">
            <v-list-item-avatar>
              <v-icon>event</v-icon>
            </v-list-item-avatar>
            <v-list-item-title class="pl-0">
              <span>{{job.startDate|formatShortDate}} at {{job.startDate|formatTime}}</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item style="height:40px" color="transparent">
            <v-list-item-avatar>
              <v-icon small>fas fa-money-bill-wave-alt</v-icon>
            </v-list-item-avatar>
            <v-list-item-title class="pl-0">
              <span v-if="!job.bid">${{ job.compensation }} {{ job.rateType === 'Hourly' ? $language.jobListItem['per hour'] : ''}}</span>
              <span v-else-if="job.bid&&job.compensation!==undefined">${{ job.compensation }} {{ job.rateType === 'Hourly' ? $language.jobListItem['per hour'] : ''}}</span>
              <span v-else>Open Bid</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item style="height:40px" color="transparent">
            <v-list-item-avatar>
              <v-icon medium>repeat</v-icon>
            </v-list-item-avatar>
            <v-list-item-title class="pl-0">
              <span>{{job.repeat}}</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>-->
    <v-divider class="mx-2"></v-divider>
    <v-row class="ma-1" v-if="job.status!=='Draft'">
      <v-card-actions>
        <v-btn outlined small elevation="2" @click="$router.push(`/hefe/job-details/${job._key}?tab=Applicants`)">
          <v-badge color="info" :content="job.numberOfApplicants" v-if="job.numberOfApplicants>0" bordered>
            <span>
              <v-icon x-small class="mr-1">people</v-icon>Applicants
            </span>
          </v-badge>
          <span v-else>
            <v-icon x-small class="mr-1">people</v-icon>Applicants
          </span>
        </v-btn>
        <div class="mx-1"></div>
        <v-btn outlined small elevation="2" @click="$router.push(`/hefe/job-details/${job._key}?tab=Messages`)">
          <v-badge color="info" :content="job.showMessageWarning" v-if="job.showMessageWarning" bordered>
            <span>
              <v-icon x-small class="mr-1">chat</v-icon>Chat
            </span>
          </v-badge>
          <span v-else>
            <v-icon x-small class="mr-1">chat</v-icon>Chat
          </span>
        </v-btn>

        <div class="mx-1"></div>
        <v-btn outlined small elevation="2" @click="$router.push(`/hefe/job-details/${job._key}?tab=Payouts`)">
          <v-icon x-small class="ma-1">far fa-credit-card</v-icon>Payouts
        </v-btn>

      </v-card-actions>
    </v-row>

    <!--    <v-divider class="mx-4" v-if="job.status!=='Draft'"></v-divider>
    <v-card-actions v-if="job.status!=='Draft'">
      <v-row justify="center" align="center" class="px-4">
        <v-btn text color="primary" depressed width="50%" @click="ratingDialog = true" v-if="job.status ==='Completed'||job.status ==='Paid'">
          <v-row justify="center">
            <v-col cols="12" align="baseline">
              <v-icon>rate_review</v-icon><span class="pl-2">Rate</span>
            </v-col>
          </v-row>
        </v-btn>
        <v-btn text depressed width="50%" @click="$router.push(`/${isPublic?'public':'obrero'}/job-details/${job._key}?tab=Summary`)" v-if="isInvite">Apply Now</v-btn>
      </v-row>
    </v-card-actions>-->

    <v-dialog v-model="ratingDialog" modal max-width="400px" transition="slide-y-reverse-transition">
      <v-card color="grey darken-3">
        <v-card-title primary-title>
          <span class="title">{{ $language.jobDetails['Review for'] }} Hefe</span>
        </v-card-title>
        <v-card-text>
          <v-layout wrap justify-center>
            <v-rating size="24" large v-model="rating.rating" color="yellow darken-3" background-color="grey darken-1" empty-icon="$vuetify.icons.ratingFull"></v-rating>
            <v-textarea outlined label="Review" v-model="rating.comment" class="mt-2"></v-textarea>
          </v-layout>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="ratingDialog = false">Cancel</v-btn>
          <v-btn color="primary" depressed @click.native="rate">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>

</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
const fb = require('@/services/firebaseConfig.js')

export default {
  props: ['jobData', 'color', 'isInvite', 'isPublic', 'fromSearch'],
  data () {
    return {
      sub: '',
      job: {
        category: 'Agriculture'
      },
      rating: {
        rating: 0,
        comment: '',
        ratedByName: '',
        ratedById: ''
      },
      ratingDialog: false

    }
  },

  mounted () {
    if (this.isInvite) {
      fb.database.ref(`jobs/${this.jobData._key}/public`).once('value').then((snapshot) => {
        this.job = snapshot.val()
      })
    } else {
      this.job = this.jobData
      this.rating = (this.jobData.rating || {})
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser']),

    isHefe () {
      if (this.job.createdBy === this.currentUser.uid) {
        return true
      }
      return false
    },
    formattedName () {
      var str = ((this.job || {}).hefeName || 'N N').split(' ')
      var name = str[0] + ' ' + str[1][0].toUpperCase() + '.'
      return name
    }
  },
  methods: {
    openDialog () {
      this.$emit('job', this.job)
    },
    async rate () {
      this.buttonLoading = true
      var updates = {}
      this.rating.ratedByName = this.userProfile.public.name
      this.rating.ratedById = this.currentUser.uid
      updates[`/user/${this.currentUser.uid}/jobs/${this.jobData._key}/rating`] = this.rating
      updates[`/user/${this.job.hefeId}/profile/public/ratings/${this.jobData._key}`] = this.rating
      fb.database.ref().update(updates)
      this.buttonLoading = false
      this.ratingDialog = false
    }

  },
  filters: {
    formatImgURL (val) {
      return '@/assets/Agriculture.svg'
    },

    trimLength (val) {
      return `${val.substring(0, 8)}...`
    },

    formatTime (val) {
      return moment(val).format('hh:mm a')
    },

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    },
    formatDesc (val) {
      if (!val) {
        return '-'
      }
      return val.length > 115 ? `${val.substring(0, 115)}...` : val
    }
  }
}
</script>
